import {saveAs} from "file-saver";

export default{


    pobierzPlik(b64Data, contentType, filename) {
        let sliceSize = 512;
        let byteCharacters = atob(b64Data);
        let byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            let slice = byteCharacters.slice(offset, offset + sliceSize);
            let byteNumbers = new Array(slice.length);

            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            let byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        let file = new File(byteArrays, filename, {type: contentType});
        saveAs(file, filename)
    }


}


// WEBPACK FOOTER //
// ./src/utilities/DownloadUtilities.js